import { Error } from '@clearkit/icons';
import { CKBannerNext, CKBox, CKButton } from 'clearkit';
import { FC } from 'react';

import AuthLayout, { AuthLayoutHeader } from '~/components/layouts/AuthLayout';
import useQueryParams from '~/hooks/useQueryParams';

import TextFieldWithValidations from '../shared/TextFieldWithValidations';
import useStartMagicLinkFlow, {
  buildErrorMessage,
  emailIsValid,
} from '../shared/useStartMagicLinkFlow';

const SignUp: FC = function() {
  const params = useQueryParams();

  let onboardingFlow = params.get('flow') || undefined;

  if (!onboardingFlow) {
    if (params.get('data_test')) onboardingFlow = 'data_test';
    if (params.get('wvr')) onboardingFlow = 'wvr';
    if (params.get('prospect')) onboardingFlow = 'prospect';
  }

  const {
    email,
    setEmail,
    isCreatingMagicLink,
    error,
    createMagicLink,
    formHandler,
    validationErrors,
  } = useStartMagicLinkFlow(onboardingFlow);

  return (
    <AuthLayout>
      <>
        <AuthLayoutHeader
          className="w-full"
          description="Enter your email address below, and we’ll send you an email to verify your account and sign in."
          header={
            <div className="w-full font-semibold">
              Create your Clearbit account
            </div>
          }
        />

        <form onSubmit={formHandler}>
          <CKBox className="w-full p-6 sm:w-[440px] gap-6">
            {error && (
              <CKBannerNext variant="error">
                <CKBannerNext.IconStatus>
                  <Error />
                </CKBannerNext.IconStatus>
                <CKBannerNext.Header>
                  Whoops, something went wrong.
                </CKBannerNext.Header>
                <CKBannerNext.Body>
                  {buildErrorMessage(error)}
                </CKBannerNext.Body>
              </CKBannerNext>
            )}

            <TextFieldWithValidations
              name="email_address"
              onChange={setEmail}
              placeholder="Email address"
              type="email"
              validationErrors={validationErrors}
              value={email}
            />
            <CKButton
              className="self-start"
              isDisabled={!emailIsValid(email)}
              isLoading={isCreatingMagicLink}
              onClick={() => createMagicLink()}
              variant="bold"
              variantColor="blue"
            >
              Create account
            </CKButton>
          </CKBox>
        </form>

        <div>
          <div className="text-sm text-center text-gray-600">
            <span>Trouble signing up?</span>
            <a
              className="pl-2 font-medium text-blue-600 hover:text-blue-500"
              href="https://help.clearbit.com/hc/en-us/articles/18895106621463-How-to-log-in-to-Clearbit"
            >
              Check out our Help Center article
            </a>
          </div>
        </div>
      </>
    </AuthLayout>
  );
};

export default SignUp;
